import createStore from "view-ui-admin/src/utils/create-store";
import Model from "@/models/admin/class-students";

export default createStore({ Model });
